import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TheCeoProblem from "./sections/TheCeoProblem";
import TheNewMavericksSolution from "./sections/TheNewMavericksSolution";
import TwoColumnLayout from "./sections/TwoColumnLayout";
import TwoColumnLayoutWithImage from "./sections/TwoColumnLayoutWithImage";
import ClientQuote from "./sections/ClientQuote";
import TheScienceOfProtection from "./sections/TheScienceOfProtection";
import ScienceOfProtection from "./sections/ScienceOfProtection";
import Team from "./sections/Team";
import TeamSection from "./sections/TeamSection";
import CallToAction from "./sections/CallToAction";
import ContactCta from "./sections/ContactCta";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="!h-[300px]">
      <Header />
      <Hero />
      <TheCeoProblem />
      <TheNewMavericksSolution />
      <TwoColumnLayout />
      <TwoColumnLayoutWithImage />
      <ClientQuote />
      <TheScienceOfProtection />
      <ScienceOfProtection />
      <Team />
      <TeamSection />
      <CallToAction />
      <ContactCta />
      <Footer />
    </div>;
}